export class FormInformation {
  Id?: number;
  UserId?: string;
  Timestamp?: Date;
  Description?: string;
  FormVersionId?: number;
  Payload: any;

  toJSON(): any {
    let toJsonObject = {
      // stringify ignores undefined
      Id: this.Id,
    };

    // Optional undefined fields should not be printed
    if (this.UserId !== undefined) {
      toJsonObject['UserId'] = this.UserId;
    }
    if (this.Timestamp !== undefined) {
      toJsonObject['Timestamp'] = this.Timestamp;
    }
    if (this.Description !== undefined) {
      toJsonObject['Description'] = this.Description;
    }
    if (this.FormVersionId !== undefined) {
      toJsonObject['FormVersionId'] = this.FormVersionId;
    }
    // Payload is saved to JSON
    if (this.Payload !== undefined) {
      toJsonObject['Payload'] = this.Payload;
    }    
    return toJsonObject;
  }
}
